

























































































import {
  defineComponent,
  ref,
  onMounted,
  Ref,
  computed
} from "@vue/composition-api";
import PrimaryContentBody from "@/vue/layouts/PrimaryContentBody.vue";
import DeleteButton from "@c/atoms/app/DeleteButton.vue";
import { useGetters, useActions } from "vuex-composition-helpers";
import { useInputRules } from "@/ts/functions/composition/inputRules";
import useFetcher from "@use/useFetcher";
import ImageInput from "@c/molecules/media/ImageInput.vue";
import Image from "@/ts/models/imageClass";
import PlaceModel from "@/ts/models/placeClass";
import ConfirmDialog from "@c/molecules/app/ConfirmDialog.vue";
import TagsInput from "@c/molecules/tag/TagsInput.vue";
import CudLayout from "@/vue/layouts/crud/CudLayout.vue";
import VisibilityInput from "@c/molecules/input/VisibilityInput.vue";
import LocationInput from "@/vue/components/molecules/input/LocationInput.vue";
import ContactInfosInput from '@/vue/components/molecules/input/ContactInfosInput.vue';


export default defineComponent({
  components: {
    PrimaryContentBody,
    ImageInput,
    ConfirmDialog,
    TagsInput,
    DeleteButton,
    CudLayout,
    VisibilityInput,
    LocationInput,
    ContactInfosInput
  },

  name: "PlaceEdition",

  setup(props, { root }) {
    var loading_deletion = ref(false);
    var loading_edit = ref(false);

    var form = ref(false);
    const rules = useInputRules();

    const { SEND_PLACE_EDITION } = useActions({
      SEND_PLACE_EDITION: "place/SEND_PLACE_EDITION"
    } as any);
    const { SEND_PLACE_DELETION } = useActions({
      SEND_PLACE_DELETION: "place/SEND_PLACE_DELETION"
    } as any);

    const place_id = parseInt(root.$route.params.id);

    var { entity: place, loading } = useFetcher(
      "place/GET_PLACE",
      {action_param:place_id,
      copy:true}
    );

    const validateUrl = (url?: string) => {
      if (url) {
        let regex = /^(http|https)/;
        if (url.length > 3 && !url.match(regex)) {
          return "http://" + url;
        } else {
          return url;
        }
      } else {
        return undefined;
      }
    };

    const validateContactInfos = () => {
      var infos = place.value.contact_infos;
      infos.facebook = validateUrl(infos.facebook);
      infos.instagram = validateUrl(infos.instagram);
      infos.youtube = validateUrl(infos.youtube);
    };

    const editPlace = () => {
      loading_edit.value = true;
      validateContactInfos()
      SEND_PLACE_EDITION(place.value)
        .then(() => {
          loading_edit.value = false;
          root.$router.push("/place/" + place_id);
        })
        .catch(() => {
          loading_edit.value = false;
        });
    };

    const deletePlace = () => {
      loading_deletion.value = true;
      SEND_PLACE_DELETION(place_id)
        .then(() => {
          loading_deletion.value = false;
          root.$router.push("/places/myplaces");
        })
        .catch(() => {
          loading_deletion.value = false;
        });
    };

    return {
      loading_edit,
      loading_deletion,
      loading,
      form,
      rules,
      place,
      editPlace,
      deletePlace
    };
  }
});
